import { Icon, type IconifyIcon } from '@iconify/react';
import { Box, type BoxProps } from '@mui/material';
import type { FC } from 'react';

export type IconifyProps = Omit<BoxProps, 'component'> & {
  icon: IconifyIcon | string;
};

const Iconify: FC<IconifyProps> = (props) => <Box component={Icon} {...props} />;

export default Iconify;
